import { LitElement, html } from 'lit';
import { repeat } from 'lit/directives/repeat';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../fit-slider/fit-slider';
import './fit-fav';

import { BreakpointBehavior } from '../fit-style/fit-breakpoint-behavior';
import { wordSlice, renderStars } from '../fit-style/fit-stars-utility';
import { FitStorageBehavior } from '../fit-storage/fit-storage-behavior';

import styles from './fit-fav-list.css';

class FitFavList extends BreakpointBehavior(FitStorageBehavior(LitElement)) {
  static get is() { return 'fit-fav-list'; }

  static get styles() { return styles; }

  render() {
    return html`
      ${this.renderItems}
        <div class="no-favs" ?hidden="${this.items.length > 0}">
          <slot></slot>
        </div>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" style="visibility: hidden; position: absolute; z-index: -1"> <defs> <linearGradient id="corner-ribbon-gradient" x1="0%" y1="100%" x2="70%" y2="0%" x3="0%" y3="100%"> <stop offset="0%" style="stop-color:rgb(236,88,64);stop-opacity:1"></stop> <stop offset="50%" style="stop-color:rgb(255,144,125);stop-opacity:1"></stop> <stop offset="100%" style="stop-color:rgb(236,88,64);stop-opacity:1"></stop> </linearGradient> </defs> </svg>
    `;
  }

  get renderItems() {
    return repeat(this.items, (item) => item.code, (item) => html`
      <div class="list-item">
        ${item.loaded
    ? html`
          <div class="image">
            <div class="image__ratio">
              <fit-slider selected="0" no-neighbour-preload one-item-per-frame>
              ${item.details.Images.map((item) => html`
                <div class="fit-slider__slide">
                  <figure class="product-teaser__image">

                    <img lazy-load-src="${item.NamedImageSizes.SearchResult}" alt="">
                    ${item.ImageOverlay ? html`
                      ${item.ImageOverlay.Html ? html`
                        <span class="product-teaser__overlay-text product-teaser__overlay-text-${item.ImageOverlay.HtmlPosition}">${unsafeHTML(item.ImageOverlay.Html)}</span>` : ''}
                      ${item.ImageOverlay.Image ? html`
                        <span class="product-teaser__overlay-image product-teaser__overlay-image-${item.ImageOverlay.ImagePosition}"><img src="${item.ImageOverlay.Image}" alt=""></span>` : ''}
                    ` : ''}
                  </figure>
                </div>
              `)}
              </fit-slider>
            </div>
          </div>
          <div class="description" @click="${this.onClick(item)}">
            <fit-fav code="${item.code}"></fit-fav>
            <h3 class="product-teaser__title">${wordSlice(item.details.Name, 0, -1)} <span class="product-teaser__title-unbreakable">${wordSlice(item.details.Name, -1)} <span class="product-teaser__subtitle--stars">${renderStars(item.details.Stars)}</span></span>
            </h3>
            <p class="product-teaser__location">
              <span class="product-teaser__country">${item.details.CountryName}</span>
              <span class="product-teaser__region">${item.details.RegionName}</span>
              <span class="product-teaser__city">${item.details.LocationName}</span>
            </p>
          </div>
           ` : html`
            <fit-spinner></fit-spinner>
          `}
        </div>
      `);
  }

  static get properties() {
    return {
      loading: {
        type: Boolean,
      },

      favList: {
        type: Array,
      },

      items: {
        type: Array,
      },
    };
  }

  get storageName() {
    return 'fit-fav';
  }

  set storageValue(favList) {
    favList = favList || [];
    this.favList = favList;

    const itemsByCode = {};
    this.items.forEach((item) => { itemsByCode[item.code] = item; });
    this.items = favList.map((code) => itemsByCode[code] || {
      code,
      loaded: false,
      loading: false,
    });

    this.loadItems();
  }

  constructor() {
    super();
    this.loading = false;
    this.items = [];
  }

  get additionalParams() {
    const url = (new URL(document.location.href));
    if (url.search.includes('?wl=1') || url.search.includes('&wl=1')) {
      return 'wl=1';
    }
    return '';
  }

  onClick(item) {
    return (event) => {
      if (event.defaultPrevented) { return; }

      let url = item.details.Url;
      const { additionalParams } = this;
      if (additionalParams) {
        url = url + (!url.includes('?') ? '?' : '&') + additionalParams;
      }
      window.location.href = url;
    };
  }

  loadItems() {
    const itemsToLoad = this.items.filter((item) => !item.loaded && !item.loading);

    if (!itemsToLoad.length) { return; }

    itemsToLoad.forEach((item) => { item.loading = true; });
    this.items = this.items.slice();

    const itemsParam = itemsToLoad.map((item) => item.code).reduce((acc, code) => `${acc}_${code}`);
    const { additionalParams } = this;
    fetch(`/json/search/?h=${encodeURIComponent(itemsParam)}${additionalParams ? `&${additionalParams}` : ''}`)
      .then((response) => response.json())
      .then((result) => {
        if (result.Hotels) {
          const hotelsByCode = {};
          result.Hotels.forEach((hotel) => hotelsByCode[hotel.Code] = hotel);
          itemsToLoad.forEach((item) => {
            if (hotelsByCode[item.code] !== undefined) {
              item.loading = false;
              item.loaded = true;
              item.details = hotelsByCode[item.code];
            }
          });
          this.items = this.items.slice();
        }
      });
  }
}

customElements.define(FitFavList.is, FitFavList);
